import PropTypes from 'prop-types'
import React from 'react'
import { UrlBuilder, formatNumber } from 'Utils'
import { Icon, Link } from 'Blocks'
import get from 'lodash/get'
import config from 'Config'
import { PAGE_CONTEXT as p } from 'Constants'
const {
  appliedFilters: { clearText }
} = config

const AppliedFilters = props => {
  const stores = get(props.data, 'products.aggregations.stores', [])
  // these are the user filters
  const filterKeys = [
    'colors',
    'category',
    'sortOn',
    'sortDirection',
    'minPrice',
    'maxPrice',
    'isOnSale',
    'stores'
  ]

  const builder = new UrlBuilder(props.queryString)
  // remove for unwanted params
  const appliedFilters = Object.keys(builder.filters)
    .filter(key => filterKeys.includes(key))
    .filter(key => builder.filters[key] !== null)
    // remove empty stores array
    .filter(key => {
      if (Array.isArray(builder.filters[key])) {
        return builder.filters[key].length > 0
      } else {
        return builder.filters[key]
      }
    })
    // remove sortOn - use sortDirection
    .filter(key => key !== 'sortOn')
    .map(key => {
      return {
        [key]: builder.filters[key]
      }
    })

  let filters = []

  let combinedPrice = {
    price: {
      min: 0,
      max: 0
    }
  }

  function getStoreName(id, stores) {
    if (stores.length > 0) {
      for (var i = 0; i < stores.length; i++) {
        if (stores[i].id === id) {
          return stores[i].name
        }
      }
    }
  }

  function combinePriceFields(filter) {
    if (Object.keys(filter)[0] === 'minPrice') {
      combinedPrice.price.min = filter[Object.keys(filter)[0]]
    }
    if (Object.keys(filter)[0] === 'maxPrice') {
      combinedPrice.price.max = filter[Object.keys(filter)[0]]
    }
  }

  function resolveFields(filter) {
    if (Object.keys(filter)[0] === 'category') {
      const builder = new UrlBuilder(props.queryString)
      const buttonLabel = `${builder.getCategory()}`
      filters.push({
        to: builder.clearCategory().getQueryString(),
        text: buttonLabel
      })
    }

    if (
      Object.keys(filter)[0] === 'minPrice' ||
      Object.keys(filter)[0] === 'maxPrice'
    ) {
      combinePriceFields(filter)
    }

    if (Object.keys(filter)[0] === 'isOnSale') {
      const builder = new UrlBuilder(props.queryString)
      filters.push({
        to: builder.removeIsOnSale().getQueryString(),
        text: 'Sale items'
      })
    }

    if (Object.keys(filter)[0] === 'sortDirection') {
      const builder = new UrlBuilder(props.queryString)
      filters.push({
        to: builder.clearSort().getQueryString(),
        text: filter.sortDirection === 'asc' ? 'Low to high' : 'High to low'
      })
    }

    if (Object.keys(filter)[0] === 'stores') {
      if (Array.isArray(filter.stores) && filter.stores.length > 0) {
        filter.stores.forEach(id => {
          const builder = new UrlBuilder(props.queryString)
          const storeName = getStoreName(parseInt(id), stores)
          if (storeName) {
            filters.push({
              text: storeName,
              to: builder.removeStore(id).getQueryString()
            })
          }
        })
      }
    }

    if (Object.keys(filter)[0] === 'colors') {
      if (Array.isArray(filter.colors) && filter.colors.length > 0) {
        filter.colors.forEach(color => {
          const builder = new UrlBuilder(props.queryString)
          if (color) {
            filters.push({
              text: color,
              to: builder.removeColor(color).getQueryString()
            })
          }
        })
      }
    }
  }

  appliedFilters.forEach(filter => {
    resolveFields(filter)
  })

  if (combinedPrice.price.min || combinedPrice.price.max) {
    const builder = new UrlBuilder(props.queryString)
    const max = combinedPrice.price.max
      ? `- ${
          config.filters.price.currencySymbol
            ? config.filters.price.currencySymbol
            : '£'
        }${combinedPrice.price.max}`
      : 'plus'
    filters.push({
      text: `${
        config.filters.price.currencySymbol
          ? config.filters.price.currencySymbol
          : '£'
      }${combinedPrice.price.min} ${max}`,
      to: builder.removeAllPrices().getQueryString()
    })
  }

  // add clear all
  if (filters.length > 1) {
    const builder = new UrlBuilder(props.queryString)
    filters.push({
      text: clearText,
      to: builder
        .removeAllColors()
        .removeAllPrices()
        .removeIsOnSale()
        .removeAllStores()
        .clearSort()
        .clearCategory()
        .getQueryString()
    })
  }

  return filters.length > 0 ? (
    <div className={`applied-filters ${props.className}`}>
      {config.appliedFilters.title &&
        props.pageName === p.PRODUCT_LIST &&
        filters.length > 0 && (
          <h3 className="applied-filters__title">
            {props.screenType !== 'small' && config.appliedFilters.title}
          </h3>
        )}
      <div className="applied-filters__links">
        {filters.map((filter, index) => {
          return (
            <Link
              to={filter.to}
              key={`applied-${index}`}
              className={`applied-filters__link ${
                filter.text === clearText && 'clear-filters'
              }`}
            >
              <span className="applied-filters__text">
                {formatNumber(filter.text)}
              </span>
              {filter.text !== clearText && (
                <Icon className="applied-filters__icon" name="close" />
              )}
            </Link>
          )
        })}
      </div>
    </div>
  ) : null
}

AppliedFilters.propTypes = {
  className: PropTypes.any,
  data: PropTypes.any,
  pageName: PropTypes.any,
  queryString: PropTypes.any,
  screenType: PropTypes.string
}

export default AppliedFilters
